import { render, staticRenderFns } from "./LayoutRSS.vue?vue&type=template&id=8cb54a4c&"
import script from "./LayoutRSS.vue?vue&type=script&lang=js&"
export * from "./LayoutRSS.vue?vue&type=script&lang=js&"
import style0 from "./LayoutRSS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports